var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { CalendarBox } from "./styles";
import miniTip from "../../MiniTip";
class Calendar extends React.Component {
    constructor() {
        super(...arguments);
        this.notAllow = () => {
            const { closeModal } = this.props;
            closeModal(false);
        };
        this.rightBtn = () => __awaiter(this, void 0, void 0, function* () {
            const { calendarData, closeModal, activeId } = this.props;
            const { isRemindMe, name = "", gpid = "", start = "", end = "", url = "" } = calendarData;
            closeModal(false);
            const type = isRemindMe ? "cancel" : "add";
            const remindResult = this.props.onReminder({
                remindType: type,
                name,
                start,
                end,
                gpid,
                url,
                remindStatus: !!isRemindMe,
                activeId
            });
            if (remindResult) {
                const { code, message } = remindResult;
                if (code === 0) {
                    const tip = !!isRemindMe
                        ? "A reminder will be sent 3 minutes before start of sale"
                        : "Cancel the reminder and you may miss the event";
                    miniTip(tip);
                }
                else {
                    miniTip(message);
                }
            }
        });
    }
    render() {
        const { isRemindMe } = this.props.calendarData;
        const text = isRemindMe
            ? "You need to open the “Notification”in Push Notifications."
            : "“ezbuy” want to get your access of your calendar.";
        const btnText = isRemindMe ? "Go Setting" : "Allow";
        return (React.createElement(CalendarBox, null,
            React.createElement("p", { className: "text" }, text),
            React.createElement("div", { className: "btns" },
                React.createElement("div", { onClick: this.notAllow }, "Not Allow"),
                React.createElement("div", { onClick: this.rightBtn }, btnText))));
    }
}
export default Calendar;
